import { toLower } from "lodash/fp";
import { DateTime } from "luxon";

/** Example format: "10:30-11:00 am" */
export const formatStartAndEndTime = (
  startTime?: DateTime,
  endTime?: DateTime | null
) => {
  if (!startTime && !endTime) return null;

  if (!startTime) return toLower(endTime!.toFormat("h:mma"));
  if (!endTime) return toLower(startTime.toFormat("h:mma"));

  return toLower(
    `${startTime.toFormat("h:mma")} - ${endTime.toFormat("h:mma")}`
  );
};

/**
 * Strips the protocol from a URL for a friendlier display value.
 * (e.g., "https://app.read.ai/foo" => "app.read.ai/foo")
 * */
export const getDisplayUrl = (linkUrl: string) =>
  linkUrl.replace(/https?:\/\//, "");
